/* eslint-disable react-hooks/exhaustive-deps */
import { TextAlignment } from "@blueprintjs/core"
import { useEffect, useRef, useState } from "react"
import { HTML } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { WriterContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useInViewport } from "src/modules/pe-landing-module/hooks/useInViewport"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { IPrimitiveProps } from "../../section/Primitive"

/* Protopia Ecosystem component */ 
const Pushkin = (props: IPrimitiveProps): JSX.Element => {
    const ref = useRef(null)
    const primitive: WriterContent = (props.primitive || {}) as WriterContent 
    const { style, className } = primitive 
    const text = primitive.text 
    const [myText, setMyText] = useState<HTML>(text)
    const position = usePosition( primitive ).position  
    const isEdit = useLandingStore((state: ILandingStore) => state.isEdit)
    const inViewport = useInViewport(ref, 300)
    const onStart = () => { 
        const elem = ref.current! as Element
        if (elem.classList.contains('mast__text js-spanize')) {
            elem.classList.remove(`mast__text js-spanize`)
        }
        elem.classList.add(`opacity_0`)
        elem.innerHTML = text
        setTimeout(() => {
            elem.className = (`mast__text js-spanize`)
            if (elem.classList.contains('opacity_0')) {
                elem.classList.remove(`opacity_0`)
            }
            let result = !isEdit 
                ?
                `<span>${text.replaceAll("</p><p>", "\n").replaceAll("<br>", "\n").split("").join("</span><span>")}</span>`
                :
                text
            elem.innerHTML = ( result )
        }, 100)
    }
    useEffect(() => {
        addCSSClass(
            `primitive-writer-${ primitive.id }`,
            ` .primitive-writer-${ primitive.id } { 
                width:${ getCssDemention(position.width, "200px") };
                user-select:none;
                //height:${ getCssDemention(position.height, "200px") };
                ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg) skew(-6deg, 0);` }
                text-align:${primitive.text_align || TextAlignment.START};
                ${ primitive.text_size   ? `font-size: ${ primitive.text_size }px!important;` : "" }
                ${ primitive.text_color  ? `color: ${primitive.text_color}!important` : "" };
                ${ primitive.font ? `font-family: ${primitive.font }!important` : ""}                
                .mast__text {
                    ${ primitive.font ? `font-family: ${primitive.font }!important` : ""}
                    ${ primitive.text_size   ? `font-size: ${ primitive.text_size }px!important;` : "" }
                }
            }`
        ) 
        let result = !isEdit 
            ?
            `<span>${text.replaceAll("</p><p>", "\n").replaceAll("<br>", "\n").split("").join("</span><span>")}</span>`
            :
            text 
        
        setMyText( result ) 
        return () => removeCSSClass(`primitive-writer-${ primitive.id }`)
    },[ position, primitive ])
    
    useEffect(() => {
        if(inViewport) {
            onStart()
        }
    }, [ inViewport ])
    return <p 
        style={ style }
        className={`${isEdit ? "" : "opacity_0" }  primitive-writer-${ primitive.id } ${ className }` } 
        dangerouslySetInnerHTML={{__html: myText}} 
        ref={ref} 
        onClick={onStart} 
    /> 
}
export default Pushkin